import styled from "styled-components";

interface ButtonTextProps {
  isLoading?: boolean;
}

const ButtonText = styled.p<ButtonTextProps>`
  opacity: ${({ isLoading }) => (isLoading ? 0 : 1)};
`;

export default ButtonText;
